import { useEffect } from "react";
import { isApp } from "@akina/utils";
import { invoke } from "@tauri-apps/api/core";

export function useGrantCameraAccess() {
  useEffect(() => {
    if (isApp) {
      invoke("grant_camera_access", { origin: window.location.origin });
    }
  }, []);
}
